import { render, staticRenderFns } from "./SetupTemplate.vue?vue&type=template&id=eb0c991c&"
import script from "./SetupTemplate.vue?vue&type=script&lang=js&"
export * from "./SetupTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SetupTemplate.vue?vue&type=style&index=0&id=eb0c991c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports